import React from "react";

export const refs = {
  firstName: React.createRef(),
  lastName: React.createRef(),
  dateOfBirth: React.createRef(),
  phoneNumber: React.createRef(),
  allowSms: React.createRef(),
  groupCode: React.createRef(),
  terms: React.createRef(),
};
